import { useState } from "react";
import { useTranslation } from "react-i18next";
import { certificatesApi } from "../services/api";
import Logo from "../components/Logo";

const T = { night:"#0A1F3D", royal:"#1263B0", cyan:"#1CBCD3",
  white:"#fff", bg:"#F7F9FC", border:"#E2E8F0" };

export default function VerifyCertificate() {
  const { t } = useTranslation();
  const [ref, setRef] = useState("");
  const [hash, setHash] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    setLoading(true);
    try {
      const r = await certificatesApi.verify(ref, hash);
      setResult({ valid: true, data: r.data?.data });
    } catch {
      setResult({ valid: false });
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:"100vh", background:T.bg, fontFamily:"'DM Sans',sans-serif",
      display:"flex", alignItems:"center", justifyContent:"center", padding:"24px" }}>
      <div style={{ background:T.white, borderRadius:"20px", padding:"40px",
        maxWidth:"480px", width:"100%", border:"1px solid #E2E8F0" }}>
        <div style={{ textAlign:"center", marginBottom:"32px" }}>
          <Logo size="md" />
          <h1 style={{ fontSize:"20px", fontWeight:700, color:T.night, marginTop:"16px" }}>
            {t("verify_cert.title")}
          </h1>
          <p style={{ color:"#64748B", fontSize:"14px" }}>{t("verify_cert.subtitle")}</p>
        </div>

        {[{label:t("verify_cert.reference"),val:ref,set:setRef,ph:t("verify_cert.reference_placeholder")},
          {label:t("verify_cert.hash"),val:hash,set:setHash,ph:t("verify_cert.hash_placeholder")}
        ].map(f => (
          <div key={f.label} style={{ marginBottom:"16px" }}>
            <label style={{ fontSize:"13px", fontWeight:600, color:"#334155",
              marginBottom:"6px", display:"block" }}>{f.label}</label>
            <input value={f.val} onChange={e=>f.set(e.target.value)}
              placeholder={f.ph}
              style={{ width:"100%", padding:"12px 16px", border:"1.5px solid #E2E8F0",
                borderRadius:"12px", fontSize:"14px", outline:"none", boxSizing:"border-box" }}/>
          </div>
        ))}

        <button onClick={handleVerify} disabled={!ref||!hash||loading}
          style={{ width:"100%", padding:"14px",
            background:ref&&hash&&!loading?T.royal:"#E2E8F0",
            color:ref&&hash&&!loading?T.white:"#94A3B8",
            border:"none", borderRadius:"12px", fontWeight:700,
            cursor:ref&&hash&&!loading?"pointer":"not-allowed", fontSize:"15px",
            marginBottom:"20px" }}>
          {loading?t("common.loading"):t("verify_cert.submit")}
        </button>

        {result && (
          <div style={{ borderRadius:"14px", padding:"20px", textAlign:"center",
            background:result.valid?"#F0FDF4":"#FEF2F2",
            border:`2px solid ${result.valid?"#16A34A":"#EF4444"}` }}>
            <div style={{ fontSize:"36px", marginBottom:"8px" }}>
              {result.valid?"✅":"❌"}
            </div>
            <div style={{ fontWeight:700, fontSize:"16px",
              color:result.valid?"#16A34A":"#B91C1C" }}>
              {result.valid?t("verify_cert.valid_title"):t("verify_cert.invalid_title")}
            </div>
            {!result.valid && (
              <p style={{ color:"#64748B", fontSize:"13px", marginTop:"8px" }}>
                {t("verify_cert.invalid_desc")}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
